module.exports = __webpack_public_path__ + "img/003.496d8787.png";